import React from 'react'
import AloWellNessLogo from '../../../../assets/images/alowellnesslogo.svg'
import { ResponsiveSVG } from 'ui/acro'

const Logo = ({
  color = 'primary',
  height = '40px',
  handleClick = () => {}
}) => {
  return (
    <ResponsiveSVG
      maxWidth={['142px', '142px', '165px']}
      height={height}
      onClick={handleClick}
      className='unstyled'
      aria-label='Navigate to ALO Wellness Club Home Page'
      id='nav_logo'
      fill={color}
      SVG={AloWellNessLogo}
    />
  )
}
export default Logo
